import ManifestScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';

import ManifestMonitoring from './monitoring';

const routes = [
  {
    path: '/manifest',
    component: ManifestScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.manifest'],
  },

  {
    path: '/manifest/monitoring',
    component: ManifestMonitoring,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.manifest'],
  },
  {
    path: '/manifest/create',
    component: CreateScreen,
    action: ['manage'],
    service: ['nvo.tms.manifest'],
  },
  {
    path: '/manifest/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.manifest'],
  },

  {
    path: '/manifest/:id/update',
    component: UpdateScreen,
    action: ['manage'],
    service: ['nvo.tms.manifest'],
  },
];

export default routes;
